"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseToast_1 = require("./BaseToast");
var mobx_react_1 = require("mobx-react");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var React = require("react");
var styles = require('./NotificationToast.scss');
var classNames = require('classnames/bind');
var WarningToast = /** @class */ (function (_super) {
    tslib_1.__extends(WarningToast, _super);
    function WarningToast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WarningToast.prototype.render = function () {
        var _a = this.props.notification, title = _a.title, description = _a.description, actionLink = _a.actionLink, cancelLink = _a.cancelLink;
        return (React.createElement("div", { className: styles.toast, onClick: this.onActionClick },
            React.createElement("div", { className: styles.iconContainer },
                React.createElement("span", { className: classNames(styles.warningIconCircle, styles.imageCircle) },
                    React.createElement(Icon_1.Icon, { className: styles.warningIcon, iconName: "Warning" /* Warning */ }))),
            React.createElement("div", { className: styles.toastInfo },
                React.createElement("div", { className: styles.warningTitle }, title),
                React.createElement("div", { className: styles.description }, description),
                React.createElement("div", { className: styles.linksContainer },
                    React.createElement("div", null, actionLink),
                    cancelLink && (React.createElement("div", { className: styles.closeLink, onClick: this.onCancelClick }, cancelLink))))));
    };
    WarningToast = tslib_1.__decorate([
        mobx_react_1.observer
    ], WarningToast);
    return WarningToast;
}(BaseToast_1.default));
exports.default = WarningToast;
//# sourceMappingURL=WarningToast.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/components/WarningToast.js
// module id = 1619
// module chunks = 3 14 105 106 107